import {helpers} from '../common/helpers';
import Swiper from 'swiper/dist/js/swiper.js';

export let sliders = {};
export let nestedSliders = null;
export let nonAutoplaySliders = {};

let slidersAutoplayBehav = {
	checkInView(slider, once) {
		let elem;

		if (slider.$container) {
			elem = slider.$container[0];
		} else {
			elem = slider.$el[0];
		}

		if (once) {
			$(elem).removeClass('is-inview');
		}

		if (helpers.isElementPartiallyInViewport(elem, 0) && !$(elem).hasClass('is-inview')) {
			$(elem).addClass('is-inview');

			if (!$('body').hasClass('is-modal-opened') && !$('body').hasClass('is-menu-opened') && window.loaderShown) {
				if (slider.autoplay) {
					slider.autoplay.start();
				} else {
					slider.startAutoplay();
				}
			}
		} else if (!helpers.isElementPartiallyInViewport(elem, 0)) {
			$(elem).removeClass('is-inview');

			if (slider.autoplay) {
				slider.autoplay.stop();
			} else {
				slider.stopAutoplay();
			}
		}
	},
};

// timer for swiper sliders
class SwiperWaitTimer {
	constructor(slider) {
		this.slider = slider;
		this.wait = 3000;

		this.state = {
			waitingTimer: null,
			waitTime: 0,
		};
	}

	startWaiting() {
		this.stopAutoplay();
		this.state.waitTime = 0;

		if (this.state.waitingTimer) {
			clearInterval(this.state.waitingTimer);
			this.state.waitingTimer = null;
			this.state.waitTime = 0;
		}

		this.state.waitingTimer = setInterval(() => {
			this.state.waitTime += 1;

			if (this.state.waitTime >= this.wait) {
				this.stopWaiting();
			}
		}, 1);
	}

	stopWaiting() {
		let self = this;

		if (this.state.waitingTimer) {
			clearInterval(this.state.waitingTimer);
			this.state.waitingTimer = null;
			this.state.waitTime = 0;

			slidersAutoplayBehav.checkInView(self.slider, true);
		}
	}

	startAutoplay() {
		if (this.state.waitingTimer) {
			return;
		}

		this.slider.autoplay.start();
	}

	stopAutoplay() {
		this.slider.autoplay.stop();
	}
}

// proto for next two sliders
export class CustomSlider {
	constructor($elem, options) {
		this.$container = $elem;
		this.$slides = $elem.find('.c-slider-item');

		this.params = {
			$btnPrev: options.btnPrev,
			$btnNext: options.btnNext,
			$pager: options.pager ? options.pager : null,
			pagItem: options.pagItem ? options.pagItem : null,
			autoplay: options.autoplay ? options.autoplay : false,
			wait: options.wait ? options.autoplay : 3000,
			onInit: options.onInit ? options.onInit : null,
			onChange: options.onChange ? options.onChange : null,
			swipe: options.swipe ? true : false,
		};

		this.state = {
			totalSlides: this.$slides.length,
			hidePag: false,
			currentSlide: 1,
			isMoving: false,
			autoplayTimer: null,
			waitingTimer: null,
			waitTime: 0,
			isNextClicked: false,
			isNextSlide: '',
		};

		if (this.$slides.length <= 1) {
			this.state.hidePag = true;
		}

		this.$slides.each((i, elem) => {
			$(elem).attr('data-slide', i + 1).addClass('is-hidden');

			if (i === 0) {
				$(elem).removeClass('is-hidden');
			}
		});

		if (this.params.$btnPrev) {
			if (this.state.hidePag) {
				this.params.$btnPrev.addClass('is-disabled');
			}

			this.params.$btnPrev.on('click', (e) => {
				$(e.currentTarget).blur();

				if (this.state.isMoving) {
					this.state.isNextClicked = true;
					this.state.isNextSlide = 'prev';
				} else {
					this.state.isNextClicked = false;
				}

				this.prevSlide();
				this.startWaiting();
			});

			this.params.$btnPrev.hover(() => {
				this.stopAutoplay();
			}, () => {
				this.startAutoplay();
			});
		}

		if (this.params.$btnNext) {
			if (this.state.hidePag) {
				this.params.$btnNext.addClass('is-disabled');
			}

			this.params.$btnNext.on('click', (e) => {
				$(e.currentTarget).blur();

				if (this.state.isMoving) {
					this.state.isNextClicked = true;
					this.state.isNextSlide = 'next';
				} else {
					this.state.isNextClicked = false;
				}

				this.nextSlide();
				this.startWaiting();
			});

			this.params.$btnNext.hover(() => {
				this.stopAutoplay();
			}, () => {
				this.startAutoplay();
			});
		}

		if (this.params.pagItem) {
			if (this.state.hidePag) {
				this.params.$pager.addClass('is-disabled');
			}

			for (let j = 0; j < this.state.totalSlides; j++) {
				this.params.$pager.append(this.params.pagItem(j + 1));
				this.params.$pager.children().eq(0).addClass('is-active');
			}

			this.params.$pager.children().on('click', (e) => {
				let activeData = $(e.currentTarget).siblings('.is-active').data('slide');
				let curData = $(e.currentTarget).data('slide');

				if ($(e.currentSlide).hasClass('is-active')) {
					return;
				}

				if (curData > activeData) {
					this.changeSlide(curData, 'next');
				} else {
					this.changeSlide(curData, 'prev');
				}

				this.startWaiting();
			});

			this.params.$pager.hover(() => {
				this.stopAutoplay();
			}, () => {
				this.startAutoplay();
			});
		}

		// append swipe
		if (this.params.swipe) {
			helpers.swipeDetect(this.$container[0], (swipeDir) => {
				if (swipeDir === 'right') {
					this.prevSlide();
					this.startWaiting();
				}

				if (swipeDir === 'left') {
					this.nextSlide();
					this.startWaiting();
				}
			});
		}

		// start autoplay
		if (this.params.autoplay) {
			this.startAutoplay();
		} else {
			this.$container.addClass('is-autoplay-stopped');
			this.params.$pager.addClass('is-autoplay-stopped');
		}

		if (this.params.onInit) {
			this.params.onInit();
		}
	}

	changeSlide(slideNum, direction) {
		let self = this;

		console.log(self, slideNum, direction);
	}

	nextSlide() {
		this.changeSlide(this.state.currentSlide + 1, 'next');
	}

	prevSlide() {
		this.changeSlide(this.state.currentSlide - 1, 'prev');
	}

	startWaiting() {
		if (!this.params.autoplay) {
			return;
		}

		this.stopAutoplay();
		this.state.waitTime = 0;

		if (this.state.waitingTimer) {
			clearInterval(this.state.waitingTimer);
			this.state.waitingTimer = null;
			this.state.waitTime = 0;
		}

		this.state.waitingTimer = setInterval(() => {
			this.state.waitTime += 1;

			if (this.state.waitTime >= this.params.wait) {
				this.stopWaiting();
			}
		}, 1);
	}

	stopWaiting() {
		let self = this;

		if (!this.params.autoplay) {
			return;
		}

		if (this.state.waitingTimer) {
			clearInterval(this.state.waitingTimer);
			this.state.waitingTimer = null;
			this.state.waitTime = 0;

			slidersAutoplayBehav.checkInView(self, true);
		}
	}

	startAutoplay() {
		if (!this.params.autoplay) {
			return;
		}

		if (this.state.waitingTimer) {
			return;
		}

		this.$container.removeClass('is-autoplay-stopped');

		if (this.params.$pager) {
			this.params.$pager.removeClass('is-autoplay-stopped');
		}

		if (this.state.autoplayTimer) {
			clearInterval(this.state.autoplayTimer);
			this.state.autoplayTimer = null;
		}

		this.state.autoplayTimer = setInterval(() => {
			this.nextSlide();
		}, this.params.autoplay);
	}

	stopAutoplay() {
		if (!this.params.autoplay) {
			return;
		}

		this.$container.addClass('is-autoplay-stopped');

		if (this.params.$pager) {
			this.params.$pager.addClass('is-autoplay-stopped');
		}

		if (this.state.autoplayTimer) {
			clearInterval(this.state.autoplayTimer);
			this.state.autoplayTimer = null;
		}
	}
}

// first screen slider
export class HeroSlider extends CustomSlider {
	changeSlide(slideNum, direction) {
		let self = this;
		let nextNum;
		let nextTransform;
		let nextTransformPerc;
		let scaleImgTime = 0.6;

		if (this.state.isNextClicked) {
			scaleImgTime = 0;
		}

		if (this.state.isMoving) {
			return;
		}

		if (slideNum > this.state.totalSlides) {
			nextNum = 1;
		} else if (slideNum < 1) {
			nextNum = this.state.totalSlides;
		} else {
			nextNum = slideNum;
		}

		let $currentSlide = this.$container.find(`[data-slide="${this.state.currentSlide}"]`);
		let $nextSlide = this.$container.find(`[data-slide="${nextNum}"]`);

		let $currentSlideCont = $currentSlide.find('.hero-item__image');
		let $nextSlideCont = $nextSlide.find('.hero-item__image');
		let $slidesImg = $('.hero-item__image');
		let $slidesImgWrap = $('.hero-item__image__inner');
		let $slidesImgShim = $('.hero-item__image__shim');

		if (direction === 'next') {
			nextTransform = -50;
			nextTransformPerc = '-100%';
			TweenMax.set($nextSlide, {
				y: '100%',
			});
		} else {
			nextTransform = 50;
			nextTransformPerc = '100%';
			TweenMax.set($nextSlide, {
				y: '-100%',
			});
		}

		TweenMax.set($nextSlideCont, {
			y: `${-nextTransform}%`,
		});

		new TimelineMax({
			onStart() {
				self.state.isMoving = true;

				if (self.params.onChange) {
					self.params.onChange(self.state.currentSlide, nextNum, direction);
				}

				if (self.params.$pager) {
					self.params.$pager.children().removeClass('is-active');
					self.params.$pager.children().eq(nextNum - 1).addClass('is-active');
				}

				$nextSlide.removeClass('is-hidden');
			},
		})
			.to($slidesImgShim, scaleImgTime * 1.3, {
				opacity: 0,
				ease: 'heroSlider',
			}, 0)
			.to($slidesImg, scaleImgTime, {
				scale: 0.5,
				ease: 'heroSlider',
			}, 0)
			.to($slidesImgWrap, scaleImgTime, {
				scale: 1.25,
				ease: 'heroSlider',
			}, 0)
			.to($currentSlide, 1.2, {
				y: nextTransformPerc,
				ease: 'heroSlider',
			}, 0.6)
			.to($currentSlideCont, 1.2, {
				y: `${-nextTransform}%`,
				ease: 'heroSlider',
			}, 0.6)
			.to($nextSlide, 1.2, {
				y: '0%',
				ease: 'heroSlider',
			}, 0.6)
			.to($nextSlideCont, 1.2, {
				y: '0%',
				ease: 'heroSlider',
			}, 0.6)
			.add(() => {
				self.state.isMoving = false;
				self.$slides.addClass('is-hidden');
				$nextSlide.removeClass('is-hidden');
				self.state.currentSlide = nextNum;

				if (!self.state.isNextClicked) {
					new TimelineMax()
						.to($slidesImgShim, 0.8, {
							opacity: 1,
							ease: 'heroSlider',
						})
						.to($slidesImg, 0.6, {
							scale: 1,
							ease: 'heroSlider',
						}, 0)
						.to($slidesImgWrap, 0.6, {
							scale: 1,
							ease: 'heroSlider',
						}, 0);
				} else {
					if (self.state.isNextSlide === 'next') {
						self.nextSlide();
					}

					if (self.state.isNextSlide === 'prev') {
						self.prevSlide();
					}

					self.state.isNextClicked = false;
				}
			}, '-=0.25');
	}
}

// slider for big images
export class ImageSlider extends CustomSlider {
	changeSlide(slideNum, direction) {
		let self = this;
		let nextNum;

		if (this.state.isMoving || this.state.totalSlides <= 1) {
			return;
		}

		if (slideNum > this.state.totalSlides) {
			nextNum = 1;
		} else if (slideNum < 1) {
			nextNum = this.state.totalSlides;
		} else {
			nextNum = slideNum;
		}

		let $currentSlide = this.$container.find(`[data-slide="${this.state.currentSlide}"]`);
		let $nextSlide = this.$container.find(`[data-slide="${nextNum}"]`);
		let $nextSlideImg = $nextSlide.find('img').length ? $nextSlide.find('img') : $nextSlide.find('.img');

		if (direction === 'next') {
			TweenMax.set($nextSlide, {
				zIndex: 3,
				x: '100%',
			});
			TweenMax.set($nextSlideImg, {
				x: '-100%',
			});

			$currentSlide.addClass('is-moving-next');
		} else {
			TweenMax.set($nextSlide, {
				zIndex: 3,
				x: '-100%',
			});
			TweenMax.set($nextSlideImg, {
				x: '100%',
			});

			$currentSlide.addClass('is-moving-prev');
		}

		new TimelineMax({
			onStart() {
				self.state.isMoving = true;

				if (self.params.onChange) {
					self.params.onChange(self.state.currentSlide, nextNum, direction);
				}

				if (self.params.$pager) {
					self.params.$pager.children().removeClass('is-active');
					self.params.$pager.children().eq(nextNum - 1).addClass('is-active');
				}

				TweenMax.set($currentSlide, {
					zIndex: 1,
				});

				$nextSlide.removeClass('is-hidden');
			},
			onComplete() {
				self.state.isMoving = false;
				self.$slides.removeClass('is-moving-next is-moving-prev');
			},
		})
			.to($nextSlide, 0.8, {
				x: '0%',
				ease: 'sliderEase',
			})
			.to($nextSlideImg, 0.8, {
				x: '0%',
				ease: 'sliderEase',
			}, '-=0.8')
			.add(() => {
				self.$slides.addClass('is-hidden');
				$nextSlide.removeClass('is-hidden');
				self.state.currentSlide = nextNum;
			});
	}
}

export function setPagerTranslate($pager, slideIndex) {
	let transBlock = $pager[0];
	let curTransform = -Math.max(36 * (slideIndex - 3), 0);

	transBlock.style.transform = `translate3d(${curTransform}px, 0, 0)`;
}

function initSliders() {
	if ($('.hero__slider').length) {
		sliders.heroSlider = new HeroSlider($('.hero__slider'), {
			btnPrev: $('.hero__controls').find('.slider-btn--prev'),
			btnNext: $('.hero__controls').find('.slider-btn--next'),
			pager: $('.hero__controls').find('.slider-pagination'),
			autoplay: 7000,

			pagItem(slideNum) {
				return `<div class="slider-pagination__item" data-slide="${slideNum}"></div>`;
			},
		});

		sliders.heroSlider.stopAutoplay();
	}

	$('.big-slider').each((i, elem) => {
		sliders[`bigSlider${i}`] = new ImageSlider($(elem).find('.image-slider'), {
			btnPrev: $(elem).closest('.big-slider').find('.slider-btn--prev'),
			btnNext: $(elem).closest('.big-slider').find('.slider-btn--next'),
			pager: $(elem).find('.slider-pagination__inner'),
			autoplay: 6000,
			swipe: true,

			pagItem(slideNum) {
				return `<div class="slider-pagination__item" data-slide="${slideNum}"></div>`;
			},

			onChange(currentSlide, nextNum) {
				setPagerTranslate(this.$pager, nextNum);

				new TimelineMax({
					onComplete() {
						TweenMax.set($(elem).find('.big-slider__text'), {
							opacity: 1,
						});
					},
				})
					.to($(elem).find('.big-slider__text'), 0.5, {
						opacity: 0,
					})
					.add(() => {
						$(elem).find('.big-slider__text').addClass('is-hidden');
						$(elem).find(`.big-slider__text[data-slide="${nextNum}"]`).removeClass('is-hidden');
					})
					.to($(elem).find(`.big-slider__text[data-slide="${nextNum}"]`), 0.6, {
						opacity: 1,
					});
			},
		});

		sliders[`bigSlider${i}`].stopAutoplay();
	});

	$('.block-slider .swiper-container').each((i, elem) => {
		sliders[`blockSlider${i}`] = new Swiper(elem, {
			slidesPerView: 1,
			spaceBetween: 24,
			speed: 650,
			grabCursor: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: $(elem).closest('.block-slider').find('.slider-btn--prev')[0],
				nextEl: $(elem).closest('.block-slider').find('.slider-btn--next')[0],
			},
			pagination: {
				el: $(elem).closest('.block-slider').find('.slider-pagination__inner')[0],
				type: 'bullets',
				clickable: true,
				renderBullet(index, className) {
					return `<div class="slider-pagination__item ${className}"></div>`;
				},
			},
			on: {
				init() {
					this.autoplay.stop();

					if (this.$el.find('.swiper-slide-active video').length) {
						this.$el.find('.swiper-slide-active video')[0].play();
					}

					if (this.slides.length <= 1) {
						$(elem).closest('.block-slider').find('.block-slider__nav').addClass('is-hidden');
					}
				},
				transitionStart() {
					$(elem).addClass('is-swiping');

					setTimeout(() => {
						$(elem).removeClass('is-swiping');
					}, 300);
				},
				transitionEnd() {
					if (this.$el.find('.swiper-slide-active video').length) {
						this.$el.find('video').each((j, videoElem) => {
							videoElem.pause();
						});

						this.$el.find('.swiper-slide-active video')[0].play();
					}
				},
				slideChange() {
					setPagerTranslate(this.pagination.$el, this.activeIndex);
				},
				autoplayStop() {
					this.$el.closest('.block-slider').addClass('is-autoplay-stopped');
				},
				autoplayStart() {
					this.$el.closest('.block-slider').removeClass('is-autoplay-stopped');
				},
			},
		});

		sliders[`blockSlider${i}`].waitTimer = new SwiperWaitTimer(sliders[`blockSlider${i}`]);

		$(elem).closest('.block-slider').find('.block-slider__nav').hover(() => {
			sliders[`blockSlider${i}`].waitTimer.stopAutoplay();
		}, () => {
			sliders[`blockSlider${i}`].waitTimer.startAutoplay();
		});

		$(elem).closest('.block-slider').find('.block-slider__nav').on('click', () => {
			sliders[`blockSlider${i}`].waitTimer.startWaiting();
		});
	});

	$('.variant-slider > .swiper-container').each((i, elem) => {
		let curDelay = 5000;

		if ($(elem).closest('.park-variants').length) {
			curDelay = 10000;
		}

		sliders[`variantSlider${i}`] = new Swiper(elem, {
			simulateTouch: false,
			noSwiping: false,
			slidesPerView: 1,
			spaceBetween: 24,
			speed: 650,
			autoplay: {
				delay: curDelay,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: $(elem).closest('.variant-slider').find('.slider-btn--prev')[0],
				nextEl: $(elem).closest('.variant-slider').find('.slider-btn--next')[0],
			},
			pagination: {
				el: $(elem).closest('.variant-slider').find('.slider-pagination__inner')[0],
				type: 'bullets',
				clickable: true,
				renderBullet(index, className) {
					return `<div class="slider-pagination__item ${className}"></div>`;
				},
			},
			on: {
				init() {
					this.autoplay.stop();

					if (this.slides.length <= 1) {
						$(elem).closest('.variant-slider').find('.variant-slider__nav').addClass('is-hidden');
					}
				},
				transitionStart() {
					$(elem).addClass('is-swiping');

					setTimeout(() => {
						$(elem).removeClass('is-swiping');
					}, 300);
				},
				transitionEnd() {
					if (nestedSliders) {
						$.each(nestedSliders, (k, slider) => {
							slider.autoplay.stop();
						});

						nestedSliders[`slider${i}-${this.activeIndex}`].autoplay.start();
					}
				},
				slideChange() {
					setPagerTranslate(this.pagination.$el, this.activeIndex);
				},
				autoplayStop() {
					this.$el.closest('.variant-slider').addClass('is-autoplay-stopped');
				},
				autoplayStart() {
					this.$el.closest('.variant-slider').removeClass('is-autoplay-stopped');
				},
			},
		});

		sliders[`variantSlider${i}`].waitTimer = new SwiperWaitTimer(sliders[`variantSlider${i}`]);

		$(elem).closest('.variant-slider').find('.variant-slider__nav').hover(() => {
			sliders[`variantSlider${i}`].waitTimer.stopAutoplay();
		}, () => {
			sliders[`variantSlider${i}`].waitTimer.startAutoplay();
		});

		$(elem).find('.variant-slider__image').hover(() => {
			sliders[`variantSlider${i}`].waitTimer.stopAutoplay();
		}, () => {
			sliders[`variantSlider${i}`].waitTimer.startAutoplay();
		});

		$(elem).closest('.variant-slider').find('.variant-slider__nav').on('click', () => {
			sliders[`variantSlider${i}`].waitTimer.startWaiting();
		});

		$(elem).find('.variant-slider__image').find('.swiper-container').each((j, nestedElem) => {
			if (j === 0 && i === 0) {
				nestedSliders = {};
			}

			nestedSliders[`slider${i}-${j}`] = new Swiper(nestedElem, {
				noSwiping: false,
				slidesPerView: 1,
				speed: 750,
				grabCursor: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				pagination: {
					el: $(nestedElem).closest('.variant-slider__image').children('.slider-pagination__inner')[0],
					type: 'bullets',
					clickable: true,
					renderBullet(index, className) {
						return `<div class="slider-pagination__item ${className}"></div>`;
					},
				},
				on: {
					init() {
						if (j !== 0 ) {
							this.autoplay.stop();
						}

						if (this.slides.length <= 1) {
							$(nestedElem).closest('.variant-slider__image').children('.slider-pagination').addClass('is-disabled');
						}
					},
					slideChange() {
						setPagerTranslate(this.pagination.$el, this.activeIndex);
					},
					autoplayStop() {
						this.$el.closest('.variant-slider__image').addClass('is-autoplay-stopped');
					},
					autoplayStart() {
						this.$el.closest('.variant-slider__image').removeClass('is-autoplay-stopped');
					},
				},
			});

			if (j !== 0 ) {
				nestedSliders[`slider${i}-${j}`].autoplay.stop();
			}
		});
	});

	$('.rewards-slider .swiper-container').each((i, elem) => {
		sliders[`rewardsSlider${i}`] = new Swiper(elem, {
			slidesPerView: 1,
			spaceBetween: 65,
			initialSlide: 1,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: $(elem).closest('.rewards-slider').find('.slider-btn--prev')[0],
				nextEl: $(elem).closest('.rewards-slider').find('.slider-btn--next')[0],
			},
			on: {
				init() {
					this.autoplay.stop();
				},
			},
		});
	});

	$('.photo-slider .swiper-container').each((i, elem) => {
		sliders[`photoSlider${i}`] = new Swiper(elem, {
			slidesPerView: 1,
			spaceBetween: 24,
			speed: 650,
			grabCursor: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: $(elem).closest('.photo-slider').find('.slider-btn--prev')[0],
				nextEl: $(elem).closest('.photo-slider').find('.slider-btn--next')[0],
			},
			pagination: {
				el: $(elem).closest('.photo-slider').find('.slider-pagination__inner')[0],
				type: 'bullets',
				clickable: true,
				renderBullet(index, className) {
					return `<div class="slider-pagination__item ${className}"></div>`;
				},
			},
			on: {
				init() {
					this.autoplay.stop();
				},
				transitionStart() {
					$(elem).addClass('is-swiping');

					setTimeout(() => {
						$(elem).removeClass('is-swiping');
					}, 300);
				},
				slideChange() {
					setPagerTranslate(this.pagination.$el, this.activeIndex);
				},
				autoplayStop() {
					this.$el.closest('.photo-slider').addClass('is-autoplay-stopped');
				},
				autoplayStart() {
					this.$el.closest('.photo-slider').removeClass('is-autoplay-stopped');
				},
			},
		});

		sliders[`photoSlider${i}`].waitTimer = new SwiperWaitTimer(sliders[`photoSlider${i}`]);

		$(elem).closest('.photo-slider').find('.photo-slider__nav').hover(() => {
			sliders[`photoSlider${i}`].waitTimer.stopAutoplay();
		}, () => {
			sliders[`photoSlider${i}`].waitTimer.startAutoplay();
		});

		$(elem).closest('.photo-slider').find('.photo-slider__nav').on('click', () => {
			sliders[`photoSlider${i}`].waitTimer.startWaiting();
		});
	});

	$('.files-slider .swiper-container').each((i, elem) => {
		let curId = $(elem).closest('.tabs__tab').data('tab');

		nonAutoplaySliders[`filesSlider${curId}`] = new Swiper(elem, {
			noSwiping: true,
			speed: 600,
			slidesPerView: 2,
			slidesPerColumn: 2,
			spaceBetween: 20,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: $(elem).closest('.files-slider').find('.slider-btn--prev')[0],
				nextEl: $(elem).closest('.files-slider').find('.slider-btn--next')[0],
			},
			pagination: {
				el: $(elem).closest('.files-slider').find('.slider-pagination__inner')[0],
				type: 'bullets',
				clickable: true,
				renderBullet(index, className) {
					return `<div class="slider-pagination__item ${className}"></div>`;
				},
			},
			on: {
				init() {
					this.autoplay.stop();
				},
				slideChange() {
					setPagerTranslate(this.pagination.$el, this.activeIndex);
				},
				autoplayStop() {
					this.$el.closest('.files-slider').addClass('is-autoplay-stopped');
				},
				autoplayStart() {
					this.$el.closest('.files-slider').removeClass('is-autoplay-stopped');
				},
			},
		});

		nonAutoplaySliders[`filesSlider${curId}`].autoplay.stop();

		if (i === 0) {
			nonAutoplaySliders[`filesSlider${curId}`].autoplay.start();
		}

		$(document).on('tabs.tabChange', () => {
			let curSliderTab = nonAutoplaySliders[`filesSlider${curId}`].$el.closest('.tabs__tab');

			nonAutoplaySliders[`filesSlider${curId}`].update();
			nonAutoplaySliders[`filesSlider${curId}`].autoplay.stop();

			if (!curSliderTab.hasClass('is-hidden')) {
				let curNum = curSliderTab.data('tab');
				nonAutoplaySliders[`filesSlider${curNum}`].autoplay.start();
			}
		});
	});

	$('.bigphoto-slider').each((i, elem) => {
		nonAutoplaySliders[`bigphotoSlider${i}`] = new ImageSlider($(elem).find('.image-slider'), {
			btnPrev: $(elem).find('.slider-btn--prev'),
			btnNext: $(elem).find('.slider-btn--next'),
			pager: $(elem).find('.slider-pagination__inner'),
			autoplay: false,

			pagItem(slideNum) {
				return `<div class="slider-pagination__item" data-slide="${slideNum}"></div>`;
			},

			onChange(currentSlide, nextNum) {
				setPagerTranslate(this.$pager, nextNum);
			}
		});
	});

	$('.banks-slider .swiper-container').each((i, elem) => {
		sliders[`banksSlider${i}`] = new Swiper(elem, {
			simulateTouch: false,
			noSwiping: false,
			slidesPerView: 1,
			spaceBetween: 24,
			speed: 650,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				prevEl: $(elem).closest('.banks-slider').find('.slider-btn--prev')[0],
				nextEl: $(elem).closest('.banks-slider').find('.slider-btn--next')[0],
			},
			pagination: {
				el: $(elem).closest('.banks-slider').find('.slider-pagination__inner')[0],
				type: 'bullets',
				clickable: true,
				renderBullet(index, className) {
					return `<div class="slider-pagination__item ${className}"></div>`;
				},
			},
			on: {
				init() {
					this.autoplay.stop();
				},
				transitionStart() {
					$(elem).addClass('is-swiping');

					setTimeout(() => {
						$(elem).removeClass('is-swiping');
					}, 300);
				},
				slideChange() {
					setPagerTranslate(this.pagination.$el, this.activeIndex);
				},
				autoplayStop() {
					this.$el.closest('.banks-slider').addClass('is-autoplay-stopped');
				},
				autoplayStart() {
					this.$el.closest('.banks-slider').removeClass('is-autoplay-stopped');
				},
			},
		});

		sliders[`banksSlider${i}`].waitTimer = new SwiperWaitTimer(sliders[`banksSlider${i}`]);

		$(elem).closest('.banks-slider').find('.banks-slider__nav').hover(() => {
			sliders[`banksSlider${i}`].waitTimer.stopAutoplay();
		}, () => {
			sliders[`banksSlider${i}`].waitTimer.startAutoplay();
		});

		$(elem).closest('.banks-slider').find('.banks-slider__nav').on('click', () => {
			sliders[`banksSlider${i}`].waitTimer.startWaiting();
		});
	});

	if ($('.contacts-address').length > 2) {
		$('.contacts-map__addresses .swiper-container').each((i, elem) => {
			nonAutoplaySliders[`contactsSlider${i}`] = new Swiper(elem, {
				slidesPerView: 2,
				spaceBetween: 20,
				navigation: {
					prevEl: $(elem).closest('.contacts-map__addresses').find('.slider-btn--prev')[0],
					nextEl: $(elem).closest('.contacts-map__addresses').find('.slider-btn--next')[0],
				},
				pagination: {
					el: $(elem).closest('.contacts-map__addresses').find('.slider-pagination__inner')[0],
					type: 'bullets',
					clickable: true,
					renderBullet(index, className) {
						return `<div class="slider-pagination__item ${className}"></div>`;
					},
				},
				on: {
					slideChange() {
						setPagerTranslate(this.pagination.$el, this.activeIndex);
					},
				}
			});
		});
	} else {
		$('.contacts-map__addresses').addClass('is-noslider');
	}

	$('.quote').each((i, elem) => {
		sliders[`quoteSlider${i}`] = new ImageSlider($(elem).find('.image-slider'), {
			pager: $(elem).find('.slider-pagination__inner'),
			autoplay: 6000,
			swipe: true,

			pagItem(slideNum) {
				return `<div class="slider-pagination__item" data-slide="${slideNum}"></div>`;
			},

			onInit() {
				if ($(elem).find('.video-preview video').length) {
					$(elem).find('.c-slider-item[data-slide="1"] .video-preview video')[0].play();
				}
			},

			onChange(currentSlide, nextNum) {
				// setPagerTranslate(this.$pager, nextNum);

				if ($(elem).find('.video-preview video').length) {
					$(elem).find('.video-preview video').each((i, video) => {
						video.pause();
					});

					$(elem).find(`.c-slider-item[data-slide="${nextNum}"] .video-preview video`)[0].play();
				}

				new TimelineMax({
					onComplete() {
						TweenMax.set($(elem).find('.quote__col'), {
							opacity: 1,
						});
					},
				})
					.to($(elem).find('.quote__col'), 0.5, {
						opacity: 0,
					})
					.add(() => {
						$(elem).find('.quote__col').addClass('is-hidden');
						$(elem).find(`.quote__col[data-slide="${nextNum}"]`).removeClass('is-hidden');
					})
					.to($(elem).find(`.quote__col[data-slide="${nextNum}"]`), 0.6, {
						opacity: 1,
					});
			},
		});
	});

	$(document).on('popup.Open', () => {
		$.each(sliders, (i, slider) => {
			if (slider.autoplay) {
				slider.autoplay.stop();
			} else {
				slider.stopAutoplay();
			}
		});
	});

	$(document).on('popup.Close', () => {
		$.each(sliders, (i, slider) => {
			slidersAutoplayBehav.checkInView(slider, true);
		});
	});

	// onscroll autoplay behav
	$(window).on('scroll', () => {
		$.each(sliders, (i, slider) => {
			slidersAutoplayBehav.checkInView(slider);
		});
	});

	$.each(sliders, (i, slider) => {
		slidersAutoplayBehav.checkInView(slider, true);
	});

	// banks items hover
	$('.banks-slider__logo').hover((e) => {
		$(e.currentTarget).closest('.banks-slider__item').addClass('is-tip-hovered');
	}, (e) => {
		$(e.currentTarget).closest('.banks-slider__item').removeClass('is-tip-hovered');
	});
}

if (helpers.isHeroShown) {
	initSliders();
} else {
	$(document).one('hero.isShown', () => {
		initSliders();
	});
}

// initSliders();
